<template>
  <div
    v-if="showLoadingState && showLoadingPendingPlanChange"
    key="loading state"
  >
    <AtomLoadingSecondary/>
  </div>
  <div v-else>
    <h2 class="m-form-title font-weight-medium font-size-xlarge">Cambio de Plan Personalizado</h2>
    <div
      v-if="ventaReemplazante"
      class="m-card-primary m-card-transition m-card-record-info"
    >
      <a
        class="m-card-record-link"
        @click="modalViewPendingChangePlan(
        Object.assign(ventaReemplazante,
        { 'producto': producto },
        {'changePlan': true}
      ))"
      >
        <p class="text-color-black-65">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.paragraph') }}
        </p>
        <p class="recod-link-call-to-action recod-link-call-to-action-billing">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.btn') }}
        </p>
      </a>
    </div>
    <div
      v-else-if="suscripcionNotificada"
      class="m-card-primary m-card-transition m-card-record-info"
    >
      <a
        class="m-card-record-link"
        @click="modalViewPendingChangePlan({
        'suscripcion': suscripcionNotificada,
        'venta': venta.venta
      })"
      >
        <p
          v-if="suscripcionNotificada.id_plan === venta.venta.id_plan"
          class="m-card-record-info m-card-record-link"
        >
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingPaymentMethod.paragraph') }}
        </p>
        <p
          v-else
          class="m-card-record-info m-card-record-link"
        >
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.paragraph') }}
        </p>
        <p class="recod-link-call-to-action recod-link-call-to-action-billing">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingPaymentMethod.btn') }}
        </p>
      </a>
    </div>
    <div
      v-else-if="showWarning"
      class="m-container-primary"
    >
      <div class="row">
        <div class="column column-3">
          <div class="m-card-record-info">
            <h4>{{ producto.nombre }}</h4>
            <p v-if="producto.trial_intervalo">
              <span class="info-text-left">
                Periodo de Prueba
              </span>
              <span class="info-text-right">
               {{ producto.trial_intervalo }} {{ $filters.getFrequencyValue(producto.trial_frecuencia, 'name') }}
              </span>
            </p>
            <p :class="(academyResourcesLicencia.alumnos > producto.maximo_alumnos) ? 'text-color-danger' : ''">
              <span class="info-text-left">
                Alumnos
                <span :class="['font-size-xsmall', 'text-color-black-45', `${(academyResourcesLicencia.alumnos > producto.maximo_alumnos) ? 'text-color-danger' : ''}`]"> ({{ academyResourcesLicencia.alumnos }} en uso)</span>
              </span>
              <span class="info-text-right">
                {{ producto.maximo_alumnos }}
              </span>
            </p>
            <p :class="(academyResourcesLicencia.administradores > producto.maximo_administradores) ? 'text-color-danger' : ''">
              <span class="info-text-left">
                Administradores
                <span :class="['font-size-xsmall', 'text-color-black-45', `${(academyResourcesLicencia.administradores > producto.maximo_administradores) ? 'text-color-danger' : ''}`]"> ({{ academyResourcesLicencia.administradores }} en uso)</span>
              </span>
              <span class="info-text-right">
                {{ producto.maximo_administradores }}
              </span>
            </p>
            <p :class="(academyResourcesLicencia.profesores > producto.maximo_profesores) ? 'text-color-danger' : ''">
              <span class="info-text-left">
                Profesores
                <span :class="['font-size-xsmall', 'text-color-black-45', `${(academyResourcesLicencia.profesores > producto.maximo_profesores) ? 'text-color-danger' : ''}`]"> ({{ academyResourcesLicencia.profesores }} en uso)</span>
              </span>
              <span class="info-text-right">
                {{ producto.maximo_profesores }}
              </span>
            </p>
            <p :class="(academyResourcesLicencia.instructores > producto.maximo_instructores) ? 'text-color-danger' : ''">
              <span class="info-text-left">
                Instructores
                <span :class="['font-size-xsmall', 'text-color-black-45', `${(academyResourcesLicencia.instructores > producto.maximo_instructores) ? 'text-color-danger' : ''}`]"> ({{ academyResourcesLicencia.instructores }} en uso)</span>
              </span>
              <span class="info-text-right">
                {{ producto.maximo_instructores }}
              </span>
            </p>
            <p>
              <span class="info-text-left">
                Cursos
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
              <span class="info-text-right"><i class="far fa-infinity"></i></span>
            </p>
            <p>
              <span class="info-text-left">
                Mapas de Aprendizaje
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
              <span class="info-text-right"><i class="far fa-infinity"></i></span>
            </p>
            <p>
              <span class="info-text-left">
                Productos
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
              <span class="info-text-right"><i class="far fa-infinity"></i></span>
            </p>
            <p>
              <span class="info-text-left">
                Puntos de Venta
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
              <span class="info-text-right"><i class="far fa-infinity"></i></span>
            </p>
            <p>
              <span class="info-text-left">
                Profesional Universidad
                </span>
              <span
                v-if="producto.tipo_universidad"
                class="info-icon-right info-icon-billing"><i class="fas fa-check"></i>
              </span>
              <span
                v-else
                class="info-text-right text-color-black-35"
              >
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
              </span>
            </p>
            <p>
              <span class="info-text-left">
                Integraciones
              </span>
              <span class="info-icon-right info-icon-billing"><i class="fas fa-check"></i></span>
            </p>
          </div> <!--fin m-card-record-info-->
        </div>
        <div class="column column-5">
          <p class="text-color-danger"><span class="font-weight-bold">Atención:</span> El plan {{ producto.nombre }} al que intentas cambiarte tiene recursos inferiores a los de tu licencia actual.</p>
          <p>Comunícate con el equipo de ventas y te ayudaremos a solucionarlo.
            Puedes escribirnos a hola@vidroop.com o hablemos por whatsapp en
            +34 644 928 797.</p>
        </div>
      </div>
    </div>
    <div v-else-if="producto && producto.cambio_plan && gestiones.length">
      <div class="m-container-primary">
        <div class="row">
          <div class="column column-4">
            <form
              autocomplete="off"
              name="personalized-plan-form"
              @submit.prevent="cambioPlan()"
            >
              <div class="display-flex-column">

                <!--Código de descuento-->
                <div class="display-flex-column margin-top-medium margin-bottom-medium">
                  <h4 class="font-weight-bold text-color-billing-primary">
                    ¿Tienes un código de descuento?
                  </h4>
                  <span class="display-flex-row margin-top-xsmall">
                  <AtomInputPrimary
                    v-model="cuponDescuento.codigo"
                    input-class="font-size-xsmall margin-left-medium"
                    placeholder="Código de Descuento"
                    reference="cupon"
                    type="text"
                    wrapper-class="font-size-xsmall margin-zero"
                    name="cupon"
                  />
                  <a
                    href="#"
                    class="a-button-primary a-button-academy-primary font-size-xsmall margin-left-small"
                    @click.prevent="updateVentaCuponDescuento()"
                  >
                    <i :class="btnCuponSending ? 'far fa-spinner fa-spin' : ''"></i>
                    Aplicar
                  </a>
                </span>
                </div>

                <!--Selección de divisa-->
                <div class="display-flex-row">
                  <p
                    v-for="(divisa, index) in divisas"
                    :key="index"
                    class="a-input-side"
                  >
                    <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
                      <input
                        v-model="divisaSelected"
                        :disabled="buttonPrimary.sending"
                        name="divisa"
                        type="radio"
                        :value="divisa"
                      >
                      <span class="a-radiobutton-checkmark"></span>
                      {{ divisa.nombre }}
                    </label>
                  </p>
                </div>

                <!--Selección de forma de pago-->
                <div
                  v-if="gestionSelected"
                  class="display-flex-column">
                  <h4 class="font-weight-bold font-size-large text-color-billing-primary">
                    Formas de Pago
                  </h4>
                  <p
                    v-for="(plan) in gestionSelected.planes"
                    :key="plan.id_producto_gestion_plan"
                    class="margin-top-zero"
                  >
                    <label class="display-flex-row a-radiobutton-primary a-radiobutton-billing-primary width-100-pr">
                      <input
                        v-model="planSelected"
                        :disabled="buttonPrimary.sending"
                        class="a-radiobutton-primary a-radiobutton-billing-primary"
                        name="formaPago"
                        type="radio"
                        :value="plan"
                      >
                      <span class="a-radiobutton-checkmark"></span>
                      <span class="margin-left-xsmall">
                      {{ divisaSelected.simbolo }} {{ plan.pago.precio }} ({{ divisaSelected.iso_code }}) {{ $utils.getPaymentFrequency(plan.pago.cuotas, plan.pago.frecuencia, plan.pago.intervalo) }}
                    </span>
                    </label>
                  </p>
                </div>

                <!--Selección de medio de pago-->
                <div
                  v-if="gestionSelected"
                  class="display-flex-column"
                >
                  <h4 class="font-weight-bold font-size-large text-color-billing-primary">
                    Medios de Pago
                  </h4>
                  <p
                    v-for="(gateway) in gestionSelected.pasarelas"
                    :key="gateway.id_academia_pasarela_pago"
                    class="margin-top-zero">
                    <label class="display-flex-row a-radiobutton-primary a-radiobutton-billing-primary width-100-pr">
                      <input
                        v-model="gatewaySelected"
                        :disabled="buttonPrimary.sending"
                        class="a-radiobutton-primary a-radiobutton-billing-primary"
                        name="medioPago"
                        type="radio"
                        :value="gateway"
                      >
                      <span class="a-radiobutton-checkmark"></span>
                      <span class="margin-left-xsmall">
                       {{ findGatewayById(gateway.pasarela_pago).nombre_publico }}
                    </span>
                      <span class="margin-left-auto">
                      <img
                        :alt="findGatewayById(gateway.pasarela_pago).nombre"
                        :src="require(`@/assets/img/gateways/${findGatewayById(gateway.pasarela_pago).nombre.toLowerCase().replace(' ', '')}.png`)"
                      >
                    </span>
                    </label>
                  </p>
                </div>

                <!--Datos de facturación-->
                <div
                  v-if="(gestionSelected && gestionSelected.punto_venta.comprobante_tipo && gestionSelected.punto_venta.comprobante_tipo > 1)"
                  class="display-flex-column margin-top-medium margin-bottom-small"
                >
                  <h4
                    v-if="gestionSelected.punto_venta.comprobante_tipo < 4"
                    class="font-weight-bold text-color-billing-primary"
                  >
                    ¿Necesitas factura completa?
                  </h4>
                  <h4
                    v-else
                    class="font-weight-bold text-color-billing-primary"
                  >
                    ¿Necesitas factura A?
                  </h4>
                  <div class="m-container-primary">
                    <div class="row">
                      <div class="column column-12">
                        <div class="display-flex-row">
                          <AtomRadioButtonPrimary
                            v-model.number="seleccion"
                            :radio-button-primary="radioButtonPrimary.factura"
                            text="No necesito"
                            :value="0"
                            wrapperClass="a-input-side a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary"
                          />
                          <AtomRadioButtonPrimary
                            v-model.number="seleccion"
                            :radio-button-primary="radioButtonPrimary.factura"
                            :text="$t('mEditionBillingMyPaymentModalChangePlan.inputs.persona.particular.label')"
                            :value="1"
                            wrapperClass="a-input-side a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary"
                            :disabled="facturaTipoComputada === 'FA'"
                          />
                          <AtomRadioButtonPrimary
                            v-model.number="seleccion"
                            :radio-button-primary="radioButtonPrimary.factura"
                            :text="$t('mEditionBillingMyPaymentModalChangePlan.inputs.persona.empresa.label')"
                            :value="2"
                            wrapperClass="a-input-side a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary"
                            :disabled="facturaTipoComputada === 'FA'"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="necesitaDatosFiscales"
                      class="row"
                    >
                      <div class="column column-4 cambio-plan-tipo-doc">
                        <AtomSelectPrimary
                          v-model.number="cliente.documento.tipo"
                          :input-error="$v.cliente.documento.tipo.$error"
                          :elements="documentoTipos"
                          :message-error="messageErrorTipoDoc"
                          @blur="$v.cliente.documento.tipo.$touch()"
                          key-field="id_documento_tipo"
                          reference="documento_tipo"
                          name="documento_tipo"
                          input-class="width-100-pr"
                          text-field="nombre"
                          wrapperClass="a-input-wrapper-column  margin-billing-data-inputs"
                          :disabled="facturaTipoComputada === 'FA'"
                        />
                      </div>
                      <div class="column column-8">
                        <AtomInputPrimary
                          v-model="cliente.documento.numero"
                          :input-error="$v.cliente.documento.numero.$error"
                          :message-error="messageErrorDocumentoNum"
                          @blur="$v.cliente.documento.numero.$touch()"
                          name="documento_numero"
                          input-class="width-100-pr"
                          placeholder="Número de Documento"
                          type="text"
                          wrapper-class="margin-billing-data-inputs display-grid"
                        />
                      </div>
                    </div>
                    <div
                      v-show="necesitaDatosFiscales"
                      class="row margin-top-small"
                    >
                      <div class="column column-12">
                        <AtomInputPrimary
                          v-model="cliente.domicilio.linea1"
                          :input-error="$v.cliente.domicilio.linea1.$error"
                          :message-error="messageErrorDireccion"
                          :blur="$v.cliente.domicilio.linea1.$touch()"
                          input-class="width-100-pr"
                          name="direccion"
                          placeholder="Dirección"
                          type="text"
                          wrapper-class="display-grid margin-billing-data-inputs"
                        />
                      </div>
                    </div>
                    <div
                      v-show="necesitaDatosFiscales"
                      class="row margin-top-small"
                    >
                      <div class="column column-8">
                        <AtomInputPrimary
                          v-model="cliente.domicilio.localidad"
                          :input-error="$v.cliente.domicilio.localidad.$error"
                          :message-error="messageErrorlocalidad"
                          @blur="$v.cliente.domicilio.localidad.$touch()"
                          input-class="width-100-pr"
                          name="ciudad"
                          placeholder="Ciudad"
                          type="text"
                          wrapper-class="margin-billing-data-inputs display-grid"
                        />
                      </div>
                      <div class="column column-4">
                        <AtomInputPrimary
                          v-model="cliente.domicilio.codigo_postal"
                          :input-error="$v.cliente.domicilio.codigo_postal.$error"
                          :message-error="messageErrorCodigoPostal"
                          @blur="$v.cliente.domicilio.codigo_postal.$touch()"
                          input-class="width-100-pr"
                          name="codigo_postal"
                          placeholder="Código Postal"
                          type="text"
                          wrapper-class="display-grid margin-billing-data-inputs"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <p
                  v-if="planSelected"
                  class="font-size-large margin-top-xlarge"
                >
                  <i class="far fa-shopping-cart margin-right-xsmall"></i>
                  Estarás pagando
                  <span
                    v-if="planSelected.plan_original"
                    class="font-weight-bold text-color-billing-primary"
                    style="text-decoration:line-through;"
                  >
                  {{divisaSelected.simbolo}}{{  planSelected.pago.cuotas ? (planSelected.plan_original.pago.cuotas * planSelected.plan_original.pago.precio).toFixed(2) : planSelected.plan_original.pago.precio }} {{ divisaSelected.iso_code }}</span>
                  <span class="font-weight-bold text-color-billing-primary">
                    {{ divisaSelected.simbolo }}{{ planSelected.pago.cuotas ? (planSelected.pago.cuotas * planSelected.pago.precio).toFixed(2) : planSelected.pago.precio }}
                    {{ divisaSelected.iso_code }}
                    <span v-if="!planSelected.pago.cuotas">
                      {{ `cada ${$filters.getFrequencyValue(planSelected.pago.frecuencia, 'name')}` }}
                    </span>
                  </span>
                </p>
                <AtomButtonPrimary :button-primary="buttonPrimary"/>
              </div>
            </form>
          </div>

          <div class="column column-3"></div>

          <div class="column column-5">
            <div class="m-card-record-info">
              <h4>{{ producto.nombre }}</h4>
              <p v-if="producto.trial_intervalo">
              <span class="info-text-left">
                Periodo de Prueba
              </span>
                <span class="info-text-right">
               {{ producto.trial_intervalo }} {{ $filters.getFrequencyValue(producto.trial_frecuencia, 'name') }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                Alumnos
                <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.alumnos }} en uso)</span>
              </span>
                <span class="info-text-right">
                {{ producto.maximo_alumnos }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                Administradores
                <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.administradores }} en uso)</span>
              </span>
                <span class="info-text-right">
                {{ producto.maximo_administradores }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                Profesores
                <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.profesores }} en uso)</span>
              </span>
                <span class="info-text-right">
                {{ producto.maximo_profesores }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                Instructores
                <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.instructores }} en uso)</span>
              </span>
                <span class="info-text-right">
                {{ producto.maximo_instructores }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                Cursos
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
                <span class="info-text-right"><i class="far fa-infinity"></i></span>
              </p>
              <p>
              <span class="info-text-left">
                Mapas de Aprendizaje
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
                <span class="info-text-right"><i class="far fa-infinity"></i></span>
              </p>
              <p>
              <span class="info-text-left">
                Productos
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
                <span class="info-text-right"><i class="far fa-infinity"></i></span>
              </p>
              <p>
              <span class="info-text-left">
                Puntos de Venta
                <span class="font-size-xsmall text-color-black-45"> (Ilimitados)</span>
              </span>
                <span class="info-text-right"><i class="far fa-infinity"></i></span>
              </p>
              <p>
              <span class="info-text-left">
                Profesional Universidad
                </span>
                <span
                  v-if="producto.tipo_universidad"
                  class="info-icon-right info-icon-billing"><i class="fas fa-check"></i>
              </span>
                <span
                  v-else
                  class="info-text-right text-color-black-35"
                >
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                Integraciones
              </span>
                <span class="info-icon-right info-icon-billing"><i class="fas fa-check"></i></span>
              </p>
            </div> <!--fin m-card-record-info-->
          </div>
        </div>
        <div
          class="row"
          style="display: block;"
        >
          <div class="column column-12">
            <div class="text-align-center">
              <h3>¿Necesitas ayuda?</h3>
              <p class="font-size-small">Escribenos a hola@vidroop.com o hablemos por Whatsapp en +34 644 928 797</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="this.gestionSelected && !this.gestionSelected.planes.length"
      class="m-card-primary m-card-record-info"
    >
      <blockquote class="quote quote-billing-primary quote-first">
        <p>
        <span>
          Este producto no tiene configurados los planes...
        </span>
        </p>
      </blockquote>
      <div class="m-edition-billing-my-payments-change-plan-help">
        <h3>¿Necesitas ayuda?</h3>
        <p class="font-size-small">Escribenos a hola@vidroop.com o hablemos por Whatsapp en +34 644 928 797</p>
      </div>
    </div>
    <div
      v-else
      class="m-card-primary m-card-record-info"
    >
      <blockquote class="quote quote-billing-primary quote-first">
        <p>
        <span>
          Este producto ya no esta disponible...
        </span>
        </p>
      </blockquote>
      <div class="m-edition-billing-my-payments-change-plan-help">
        <h3>¿Necesitas ayuda?</h3>
        <p class="font-size-small">Escribenos a hola@vidroop.com o hablemos por Whatsapp en +34 644 928 797</p>
      </div>
    </div>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionBillingCustomizedPlanChange',

  data () {
    return {
      btnCuponSending: false,
      buttonPrimary: {
        action: 'Confirmar',
        class: 'width-fit-content a-button-billing-primary margin-bottom-xxlarge margin-top-large',
        sending: false,
        type: 'submit'
      },

      cuponDescuento: {
        producto: this.$route.params.subid,
        codigo: ''
      },

      cliente: {
        comprobanteTipo: '',
        domicilio: {
          codigo_postal: '',
          linea1: '',
          linea2: '',
          localidad: ''
        },
        documento: {
          numero: '',
          tipo: ''
        },
        factura_tipo: '',
        fisica: ''
      },

      divisas: [],

      divisaSelected: null,

      documentoTipos: [],

      gestiones: [],

      gatewaySelected: null,

      gestionSelected: null,

      necesitaDatosFiscales: false,

      pasarelas: [],

      producto: null,

      pasarelaSelected: null,

      planSelected: null,

      planDescuento: null,

      tieneCupon: false,

      quote: '',

      quotedPrice: '',

      radioButtonPrimary: {
        factura: {
          labelClass: 'a-radiobutton-billing-primary',
          name: 'tipo-de-factura'
        }
      },

      seleccion: 0,

      showLoadingState: true,

      showLoadingPendingPlanChange: true,

      i: 0,

      showBillingData: false,

      suscripcionNotificada: null,

      venta: null,

      ventaReemplazante: null
    }
  },

  validations: {
    cliente: {
      documento: {
        numero: {
          maxLength: maxLength(30),
          minLength: minLength(3),
          required
        },

        tipo: {
          required
        }
      },

      domicilio: {
        codigo_postal: {
          required
        },

        linea1: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        },

        localidad: {
          maxLength: maxLength(60),
          required
        }
      }
    }
  },

  computed: {
    academyResourcesLicencia () {
      return this.$store.getters.getAcademyResources
    },

    showWarning () {
      return this.academyResourcesLicencia.alumnos > this.producto.maximo_alumnos ||
        this.academyResourcesLicencia.administradores > this.producto.maximo_administradores ||
        this.academyResourcesLicencia.profesores > this.producto.maximo_profesores ||
        this.academyResourcesLicencia.instructores > this.producto.maximo_instructores
    },

    messageErrorCodigoPostal () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.domicilio.codigo_postal, 'cliente', 'codigo_postal')
    },

    messageErrorDireccion () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.domicilio.linea1, 'cliente', 'direccion')
    },

    messageErrorDocumentoNum () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.documento.numero, 'cliente', 'documento_numero')
    },

    messageErrorlocalidad () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.domicilio.localidad, 'cliente', 'localidad')
    },

    messageErrorTipoDoc () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.documento.tipo, 'cliente', 'documento_tipo')
    },

    facturaTipoComputada () {
      if (!this.cliente.comprobanteTipo || this.cliente.comprobanteTipo === 1) {
        return null
      }

      // Espana
      if (this.cliente.comprobanteTipo > 1 && this.cliente.comprobanteTipo < 4) {
        if (this.quotedPrice > 3000) {
          return 'FC'
        }

        return this.seleccion === 0 ? 'FS' : 'FC'
      }

      // Argentina
      if (this.cliente.comprobanteTipo === 4) {
        return this.seleccion === 0 ? 'FB' : 'FA'
      }

      return null
    }
  },

  watch: {
    divisaSelected: {
      handler () {
        this.gestionSelected = this.gestiones.find((g) => this.divisaSelected && g.divisa.id_divisa === this.divisaSelected.id_divisa)
      },

      immediate: false
    },

    facturaTipoComputada: {
      handler (nuevoTipo) {
        this.necesitaDatosFiscales = ['FA', 'FB', 'FC'].includes(nuevoTipo)

        const tipoConfig = {
          'FA': { seleccion: 2, fisica: 0, docTipo: 10 },
          'FB': { seleccion: 0, fisica: 1 },
          'FS': { seleccion: 0 }
        }

        const config = tipoConfig[nuevoTipo]

        if (config) {
          this.seleccion = config.seleccion
          if (config.fisica !== undefined) {
            this.cliente.fisica = config.fisica
          }
          if (config.docTipo !== undefined) {
            this.cliente.documento.tipo = config.docTipo
          }
        }
      },
      immediate: true
    },

    gestionSelected: {
      handler () {
        if (this.gestionSelected) {
          if (this.gestionSelected.punto_venta &&
            this.gestionSelected.punto_venta.comprobante_tipo &&
            this.gestionSelected.punto_venta.comprobante_tipo !== 1) {
            this.readParametroCotizacion(this.gestionSelected.planes[0])
          } else {
            this.quote = 1
            this.planSelected = this.gestionSelected.planes[0]
            this.gatewaySelected = this.gestionSelected.pasarelas[0]
          }
        }
      },
      immediate: true
    },

    planSelected (plan) {
      if (plan) {
        this.quotedPrice = (plan.pago.precio * this.quote).toFixed(2)
      }
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readChangePlan()
  },

  methods: {
    cambioPlan () {
      let valid = !(this.planSelected && this.gatewaySelected)
      if (!valid && this.cliente.factura_completa) {
        this.$v.$touch()
        this.$nextTick(() => this.$validation.focusInputError(this))
        valid = this.$v.$invalid
      }
      if (!this.buttonPrimary.sending && !valid) {
        this.buttonPrimary.sending = true
        this.cliente.factura_tipo = this.facturaTipoComputada
        this.$services.create('ventas', 'changePlan', Object.assign(
          {},
          { academia: this.$store.getters.getAcademyData.id },
          { producto: this.producto.id },
          { plan: this.planSelected.id_producto_gestion_plan },
          { pasarela: this.gatewaySelected.id_academia_pasarela_pago },
          { cliente: this.cliente }), [ this.venta.venta.id_venta ])
          .then(response => {
            this.$utils.isUrl(response.data)
              ? window.location.replace(response.data)
              : this.findGatewayById(this.gatewaySelected.pasarela_pago).nombre === 'Paypal'
                ? this.$paypal.formPaypal(JSON.parse(response.data))
                : this.$stripe.init(Object.assign(
                  {},
                  { stripeAccount: this.gatewaySelected.configuracion['id'] },
                  { sessionId: response.data })
                )
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'changePlan', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
            console.log(error)
          })
      }
    },

    findGatewayById (id) {
      return this.pasarelas.find(gw => gw.id === id)
    },

    modalViewPendingChangePlan (params) {
      this.$modal.showModal('MoleculeEditionBillingModalPendingCustomizedPlanChange', params)
    },

    readChangePlan () {
      this.$services.read('ventas', 'readChangePlan', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          if (response.status === 204) {
            this.readSubscriptionNotificada()
          } else {
            this.ventaReemplazante = response.data
            this.readProducto()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data.filter(divisa =>
            this.gestiones.some(gestion => gestion.divisa.id_divisa === divisa.id_divisa && gestion.planes.length)
          )
          this.divisaSelected = this.divisas.find((d) => d.iso_code === this.venta.venta && this.venta.venta.divisa_iso_code) || this.divisas[0]
          this.readParametroDocumentoTipos()
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroCotizacion (plan) {
      this.$services.read('parametro', 'readParametroCotizacion', {}, [plan.id_producto_gestion_plan])
        .then(response => {
          this.quote = response.data.cotizacion
          this.cliente.comprobanteTipo = response.data.comprobante_tipo
          this.planSelected = this.gestionSelected.planes[0]
          this.gatewaySelected = this.gestionSelected.pasarelas[0]
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroDocumentoTipos () {
      this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [this.venta.cliente.datos_personales.domicilio.provincia.pais.id_pais])
        .then(response => {
          this.documentoTipos = response.data
          if (this.venta.cliente.datos_personales) {
            this.cliente.factura_completa = +(this.venta.venta.detalle && this.venta.venta.detalle.comprobante.facturaCompleta)
            this.cliente.fisica = +this.venta.cliente.datos_personales.fisica

            if (this.cliente.factura_completa) {
              this.seleccion = this.cliente.fisica ? 1 : 2
            } else {
              this.seleccion = 0
            }

            if (this.venta.cliente.datos_personales.domicilio) {
              this.cliente.domicilio.codigo_postal = this.venta.cliente.datos_personales.domicilio.codigo_postal
                ? this.venta.cliente.datos_personales.domicilio.codigo_postal
                : ''

              this.cliente.domicilio.linea1 = this.venta.cliente.datos_personales.domicilio.linea1
                ? this.venta.cliente.datos_personales.domicilio.linea1
                : ''

              this.cliente.domicilio.linea2 = this.venta.cliente.datos_personales.domicilio.linea2
                ? this.venta.cliente.datos_personales.domicilio.linea2
                : ''

              this.cliente.domicilio.localidad = this.venta.cliente.datos_personales.domicilio.localidad
                ? this.venta.cliente.datos_personales.domicilio.localidad
                : ''
            }

            if (this.venta.cliente.datos_personales.documento && this.venta.cliente.datos_personales.documento.numero !== 0) {
              this.cliente.documento.numero = this.venta.cliente.datos_personales.documento.numero
                ? this.venta.cliente.datos_personales.documento.numero
                : ''

              this.cliente.documento.tipo = this.venta.cliente.datos_personales.documento.tipo.id_documento_tipo
                ? this.venta.cliente.datos_personales.documento.tipo.id_documento_tipo
                : ''
            }

            this.cliente.factura_tipo = this.venta.cliente.factura_tipo
              ? this.venta.cliente.factura_tipo.value
              : null

            this.necesitaDatosFiscales = this.venta.cliente.factura_tipo
              ? ['FA', 'FB', 'FC'].includes(this.venta.cliente.factura_tipo.value)
              : false

            this.seleccion = this.necesitaDatosFiscales
              ? +this.cliente.fisica++
              : 0
          }
          this.showLoadingState = false
          this.showLoadingPendingPlanChange = false
        })
        .catch(error => {
          console.log(error)
          this.documentoTipos = []
        })
    },

    readPasarelas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.readVenta()
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProducto () {
      this.$services.read('ventas', 'readProductoPublico', {}, [this.$route.params.subid])
        .then(response => {
          this.producto = response.data
          if (this.ventaReemplazante) {
            this.showLoadingState = false
            this.showLoadingPendingPlanChange = false
          } else {
            this.readProductoGestiones()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductoGestiones () {
      this.$services.read('ventas', 'readProductoGestionesPublico', {}, [this.$route.params.subid])
        .then(response => {
          this.gestiones = [...response.data]
          this.readPasarelas()
        })
        .catch(error => {
          console.log(error)
        })
    },

    readSubscriptionNotificada () {
      this.$services.read('ventas', 'readSubscriptionNotificada', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          if (response.status === 204) {
            this.readProducto()
          } else {
            this.suscripcionNotificada = response.data
            this.readVenta()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          this.venta = response.data
          if (this.suscripcionNotificada) {
            this.showLoadingState = false
            this.showLoadingPendingPlanChange = false
          } else {
            this.readDivisas()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    updateVentaCuponDescuento () {
      if (!this.btnCuponSending) {
        this.btnCuponSending = true
        this.$services.create('ventas', 'updateVentaCuponDescuento', this.cuponDescuento)
          .then(response => {
            if (response.data.cupon.tipo_desc === 'gratis') {
              this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'cupon', 'gratis', 'a-alert-danger')
              this.btnCuponSending = false
            } else {
              this.gestiones = response.data.gestiones
              this.gestionSelected = this.gestiones.find((g) => g.divisa.id_divisa === this.divisaSelected.id_divisa)
              this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'cupon', 'success')
              this.btnCuponSending = false
            }
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'cupon', 'error', 'a-alert-danger')
            this.btnCuponSending = false
          })
      }
    }
  }
}
</script>

<style scoped>
.margin-billing-data-inputs {
  margin: 2px;

  @media (--viewport-medium) {
    margin: 0;
  }
}
</style>
